import { notificationHandler } from './common';

export function initialiseDeleteModal(deleteAlertUrl: string) {
    let close = document.getElementById("delete-modal-close") as HTMLElement;
    close.addEventListener('click', hideDeleteModal);
    
    let modalBkgd = document.getElementById("delete-alert-from-email-modal") as HTMLDialogElement;
    modalBkgd.addEventListener('click', function(e) {
        if (e.target == this) {
            hideDeleteModal();
        }
    });
    
    let deleteAlertModalButton = document.getElementById("delete-alert") as HTMLAnchorElement;
    deleteAlertModalButton.addEventListener('click', function(e) {
        let alertGUID = (e.target as HTMLElement).getAttribute("data-alert-guid")!;
        deleteAlert(this, alertGUID, deleteAlertUrl);
    });

    modalBkgd.showModal();
}

function deleteAlert(deleteAlertModalButton: HTMLAnchorElement, alertGUID: string, deleteAlertUrl: string) {
    deleteAlertModalButton.classList.add('submitting');
    fetch(deleteAlertUrl, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            alertGUID: alertGUID
        })
    }).then(response => response.json()).then(response => {
        deleteAlertModalButton.classList.remove('submitting');
        notificationHandler(response.message, response.status);
        hideDeleteModal();
    }).catch(error => {
        deleteAlertModalButton.classList.remove('submitting');
        notificationHandler("There was an error deleting your alert. Please try again later.", 'error');
        hideDeleteModal();
    });
}

function hideDeleteModal() {
    let modal = document.getElementById("delete-alert-from-email-modal") as HTMLDialogElement;
    modal.close();
}